import React from "react";

function FooterCopy() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="text-center py-4 bg-[#23346E] text-gray-400">
      <a
        href="http://www.inteligen-t.com"
        className="inline-block mb-2"
      >
        <img 
          src="/img/logo/inteligen-t_white.svg" 
          alt="logo inteligen-t" 
          className="h-8 mx-auto"
        />
      </a>
      <p>
        Copyright © {currentYear}, Todos los derechos reservados Border Protect Seguridad Privada
      </p>
    </div>
  );
}

export default FooterCopy;